import { z } from "zod";

import { Id } from "./ids";

/** Who pays: an organisation, where admins choose leaders and readers, or a band, where everyone leads. */
export const Plan = z.enum(["organisation", "band"]);

export type Plan = z.infer<typeof Plan>;

/** A place for one person: a leader makes and changes shared setlists, a reader only gets them. */
export const Seat = z.enum(["leader", "reader"]);

export type Seat = z.infer<typeof Seat>;

/** `PUT /groups/:groupId/people/:accountId`: changes someone's seat in a group, or whether they're an admin. */
export const PersonChange = z.object({
    /** No seat is only for an admin who doesn't lead or read. */
    seat: Seat.nullable(),
    admin: z.boolean(),
});

export type PersonChange = z.infer<typeof PersonChange>;

/** `GET /groups/:groupId/people`: everyone in a group, for its people to see who's who. */
export const GroupPeople = z.object({
    people: z.array(
        z.object({
            accountId: Id,
            name: z.string(),
            seat: Seat.nullable(),
            admin: z.boolean(),
            /** When they last fetched the group's setlists. A seat unused for 60 days is free for someone else. */
            lastUsedAt: z.iso.datetime().nullable(),
        }),
    ),
});

export type GroupPeople = z.infer<typeof GroupPeople>;
